import { IAddress } from '@Components/index'

export class Address {

  public static createDefaultAddress(): IAddress {
		return {id: '-1', number: '', street: '', zipcode: '', city: '', country: '', formatted: '', error: false}
	}
}